'use strict';

var keyMirror = require('react/lib/keyMirror');

module.exports = keyMirror({
  CHANGE_ROUTE: null,

  PRELOAD_ZINE: null,
  REQUEST_ZINE: null,
  REQUEST_ZINE_SUCCESS: null,
  REQUEST_ZINE_ERROR: null,

  INVALIDATE_ZINE_LATEST_STAMPS: null,
  PRELOAD_ZINE_LATEST_STAMPS: null,
  REQUEST_ZINE_LATEST_STAMPS: null,
  REQUEST_ZINE_LATEST_STAMPS_ERROR: null,
  REQUEST_ZINE_LATEST_STAMPS_SUCCESS: null,

  PRELOAD_ZINE_PENDING_STAMPS: null,
  REQUEST_ZINE_PENDING_STAMPS: null,
  REQUEST_ZINE_PENDING_STAMPS_ERROR: null,
  REQUEST_ZINE_PENDING_STAMPS_SUCCESS: null,

  FOLLOW_ZINE: null,
  FOLLOW_ZINE_SUCCESS: null,
  FOLLOW_ZINE_ERROR: null,

  UNFOLLOW_ZINE: null,
  UNFOLLOW_ZINE_SUCCESS: null,
  UNFOLLOW_ZINE_ERROR: null,

  FOLLOW_USER: null,
  FOLLOW_USER_SUCCESS: null,
  FOLLOW_USER_ERROR: null,

  UNFOLLOW_USER: null,
  UNFOLLOW_USER_SUCCESS: null,
  UNFOLLOW_USER_ERROR: null,

  DELETE_ZINE: null,
  DELETE_ZINE_SUCCESS: null,
  DELETE_ZINE_ERROR: null,

  ADD_STAMP_TO_ZINE: null,
  ADD_STAMP_TO_ZINE_SUCCESS: null,
  ADD_STAMP_TO_ZINE_ERROR: null,

  SUBMIT_STAMP_TO_ZINE: null,
  SUBMIT_STAMP_TO_ZINE_SUCCESS: null,
  SUBMIT_STAMP_TO_ZINE_ERROR: null,

  REMOVE_STAMP_FROM_ZINE: null,
  REMOVE_STAMP_FROM_ZINE_SUCCESS: null,
  REMOVE_STAMP_FROM_ZINE_ERROR: null,

  APPROVE_STAMP_TO_ZINE: null,
  APPROVE_STAMP_TO_ZINE_SUCCESS: null,
  APPROVE_STAMP_TO_ZINE_ERROR: null,

  REJECT_STAMP_FROM_ZINE: null,
  REJECT_STAMP_FROM_ZINE_SUCCESS: null,
  REJECT_STAMP_FROM_ZINE_ERROR: null,

  CREATE_ZINE_DRAFT: null,
  UPDATE_ZINE_DRAFT: null,
  DESTROY_ZINE_DRAFT: null,

  CREATE_ZINE: null,
  CREATE_ZINE_SUCCESS: null,
  CREATE_ZINE_ERROR: null,

  UPDATE_ZINE: null,
  UPDATE_ZINE_SUCCESS: null,
  UPDATE_ZINE_ERROR: null,

  SPECIFY_CURRENT_USER: null,

  PRELOAD_USER: null,
  REQUEST_USER: null,
  REQUEST_USER_SUCCESS: null,
  REQUEST_USER_ERROR: null,

  PRELOAD_STAMP: null,
  REQUEST_STAMP: null,
  REQUEST_STAMP_SUCCESS: null,
  REQUEST_STAMP_ERROR: null,

  DELETE_STAMP: null,
  DELETE_STAMP_SUCCESS: null,
  DELETE_STAMP_ERROR: null,

  POST_STAMP: null,
  POST_STAMP_SUCCESS: null,
  POST_STAMP_ERROR: null,

  UPDATE_STAMP: null,
  UPDATE_STAMP_SUCCESS: null,
  UPDATE_STAMP_ERROR: null,

  LIKE_STAMP: null,
  LIKE_STAMP_SUCCESS: null,
  LIKE_STAMP_ERROR: null,

  UNLIKE_STAMP: null,
  UNLIKE_STAMP_SUCCESS: null,
  UNLIKE_STAMP_ERROR: null,

  INCREMENT_STAMP_VIEWS: null,

  PRELOAD_SUGGESTED_ZINES: null,
  REQUEST_SUGGESTED_ZINES: null,
  REQUEST_SUGGESTED_ZINES_SUCCESS: null,
  REQUEST_SUGGESTED_ZINES_ERROR: null,

  INVALIDATE_FEED_WITH_TRENDING: null,
  PRELOAD_FEED: null,
  REQUEST_FEED: null,
  REQUEST_FEED_SUCCESS: null,
  REQUEST_FEED_ERROR: null,
  PRELOAD_TRENDING_STAMPS: null,
  REQUEST_TRENDING_STAMPS: null,
  REQUEST_TRENDING_STAMPS_SUCCESS: null,
  REQUEST_TRENDING_STAMPS_ERROR: null,

  PRELOAD_ZINE_SECTIONS: null,
  REQUEST_ZINE_SECTIONS: null,
  REQUEST_ZINE_SECTIONS_SUCCESS: null,
  REQUEST_ZINE_SECTIONS_ERROR: null,

  PRELOAD_ZINES_IN_SECTION: null,
  REQUEST_ZINES_IN_SECTION: null,
  REQUEST_ZINES_IN_SECTION_SUCCESS: null,
  REQUEST_ZINES_IN_SECTION_ERROR: null,

  INVALIDATE_USER_LATEST_STAMPS: null,
  PRELOAD_USER_LATEST_STAMPS: null,
  REQUEST_USER_LATEST_STAMPS: null,
  REQUEST_USER_LATEST_STAMPS_SUCCESS: null,
  REQUEST_USER_LATEST_STAMPS_ERROR: null,

  PRELOAD_USER_LIKED_STAMPS: null,
  REQUEST_USER_LIKED_STAMPS: null,
  REQUEST_USER_LIKED_STAMPS_SUCCESS: null,
  REQUEST_USER_LIKED_STAMPS_ERROR: null,

  PRELOAD_USER_CURATED_ZINES: null,
  REQUEST_USER_CURATED_ZINES: null,
  REQUEST_USER_CURATED_ZINES_ERROR: null,
  REQUEST_USER_CURATED_ZINES_SUCCESS: null,

  REQUEST_USER_CURATED_UNLISTED_ZINES: null,
  REQUEST_USER_CURATED_UNLISTED_ZINES_ERROR: null,
  REQUEST_USER_CURATED_UNLISTED_ZINES_SUCCESS: null,

  PRELOAD_USER_CONTRIBUTED_ZINES: null,
  REQUEST_USER_CONTRIBUTED_ZINES: null,
  REQUEST_USER_CONTRIBUTED_ZINES_ERROR: null,
  REQUEST_USER_CONTRIBUTED_ZINES_SUCCESS: null,

  REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES: null,
  REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_ERROR: null,
  REQUEST_USER_CONTRIBUTED_UNLISTED_ZINES_SUCCESS: null,

  REQUEST_INVITATIONS: null,
  REQUEST_INVITATIONS_ERROR: null,
  REQUEST_INVITATIONS_SUCCESS: null,

  REQUEST_ACTIVITIES: null,
  REQUEST_ACTIVITIES_ERROR: null,
  REQUEST_ACTIVITIES_SUCCESS: null,
  INVALIDATE_ACTIVITIES: null,

  REQUEST_UNSEEN_ACTIVITY_COUNT: null,
  REQUEST_UNSEEN_ACTIVITY_COUNT_ERROR: null,
  REQUEST_UNSEEN_ACTIVITY_COUNT_SUCCESS: null,

  ACTIVITY_MARK_ALL: null,
  ACTIVITY_MARK_ALL_ERROR: null,
  ACTIVITY_MARK_ALL_SUCCESS: null,

  REQUEST_SOCIAL_FRIENDS: null,
  REQUEST_SOCIAL_FRIENDS_ERROR: null,
  REQUEST_SOCIAL_FRIENDS_SUCCESS: null,

  SEND_INVITE: null,
  SEND_INVITE_ERROR: null,
  SEND_INVITE_SUCCESS: null,

  RESEND_INVITE: null,
  RESEND_INVITE_ERROR: null,
  RESEND_INVITE_SUCCESS: null,

  UPDATE_INVITE: null,
  UPDATE_INVITE_ERROR: null,
  UPDATE_INVITE_SUCCESS: null,

  SEND_FB_INVITE: null,
  SEND_FB_INVITE_ERROR: null,
  SEND_FB_INVITE_SUCCESS: null,

  SET_NAVIGATION_CONTEXT: null,
  CLEAR_NAVIGATION_CONTEXT: null,

  SHOW_NOTIFICATION: null,
  HIDE_NOTIFICATION: null,

  SHOW_ALERT: null,
  HIDE_ALERT: null,
  SHOW_MODAL: null,
  HIDE_MODAL: null,
  SHOW_SIDEBAR: null,
  HIDE_SIDEBAR: null,
  HIDE_OVERLAY: null,

  SHOW_CONTEXT_MENU: null,
  HIDE_CONTEXT_MENU: null,

  SHOW_PAGE_CONTROLS: null,
  HIDE_PAGE_CONTROLS: null,

  TOGGLE_SERVICE_ACCOUNT_HIDDEN: null,
  TOGGLE_SERVICE_ACCOUNT_HIDDEN_SUCCESS: null,
  TOGGLE_SERVICE_ACCOUNT_HIDDEN_ERROR: null,

  CONNECT_SERVICE_ACCOUNT: null,
  CONNECT_SERVICE_ACCOUNT_SUCCESS: null,
  CONNECT_SERVICE_ACCOUNT_ERROR: null,

  DISCONNECT_SERVICE_ACCOUNT: null,
  DISCONNECT_SERVICE_ACCOUNT_SUCCESS: null,
  DISCONNECT_SERVICE_ACCOUNT_ERROR: null,

  LOGIN_WITH_SERVICE_ACCOUNT: null,
  LOGIN_WITH_SERVICE_ACCOUNT_SUCCESS: null,
  LOGIN_WITH_SERVICE_ACCOUNT_ERROR: null,

  SIGNUP_WITH_SERVICE_ACCOUNT: null,
  SIGNUP_WITH_SERVICE_ACCOUNT_SUCCESS: null,
  SIGNUP_WITH_SERVICE_ACCOUNT_ERROR: null,

  SHARE_STAMP: null,
  SHARE_ZINE: null,
  SHARE_USER: null,
  SHARE_JOINED: null,

  SHOW_FORM_MESSAGES: null,
  HIDE_FORM_MESSAGES: null,

  FORM_VALUE_CHANGED: null,

  SUBMIT_FORM: null,
  SUBMIT_FORM_SUCCESS: null,
  SUBMIT_FORM_ERROR: null,

  RESET_FORM: null,

  SAVE_SETTINGS: null,
  SAVE_SETTINGS_SUCCESS: null,
  SAVE_SETTINGS_ERROR: null,

  REQUEST_RESET_PASSWORD: null,
  REQUEST_RESET_PASSWORD_SUCCESS: null,
  REQUEST_RESET_PASSWORD_ERROR: null,

  RESET_PASSWORD: null,
  RESET_PASSWORD_SUCCESS: null,
  RESET_PASSWORD_ERROR: null,

  ENABLE_EMAIL_NOTIFICATION: null,
  DISABLE_EMAIL_NOTIFICATION: null,
  SAVE_EMAIL_NOTIFICATION_SETTINGS_SUCCESS: null,
  SAVE_EMAIL_NOTIFICATION_SETTINGS_ERROR: null,

  LOGOUT: null,
  SPECIFY_LOGIN_OPTIONS: null,

  LOGIN_WITH_EMAIL: null,
  LOGIN_WITH_EMAIL_SUCCESS: null,
  LOGIN_WITH_EMAIL_ERROR: null,

  FEEDBACK: null,
  FEEDBACK_SUCCESS: null,
  FEEDBACK_ERROR: null,

  RESEND_UNCONFIRMED_EMAIL: null,
  RESEND_UNCONFIRMED_EMAIL_SUCCESS: null,
  RESEND_UNCONFIRMED_EMAIL_ERROR: null,

  CANCEL_UNCONFIRMED_EMAIL: null,
  CANCEL_UNCONFIRMED_EMAIL_SUCCESS: null,
  CANCEL_UNCONFIRMED_EMAIL_ERROR: null,

  RESUBSCRIBE_EMAIL: null,
  RESUBSCRIBE_EMAIL_SUCCESS: null,
  RESUBSCRIBE_EMAIL_ERROR: null,

  ENTER_LIGHTBOX: null,
  LEAVE_LIGHTBOX: null,

  INVITATION_FORM_PUSH_TAG: null,
  INVITATION_FORM_CLEAR_SUGGESTED: null,

  RESIZE_WINDOW: null,

  REQUEST_MEDIA_DATA: null,
  REQUEST_MEDIA_DATA_SUCCESS: null,
  REQUEST_MEDIA_DATA_ERROR: null,

  LOAD_STAMP_IN_EDITOR: null,
  LOAD_STAMP_IN_EDITOR_SUCCESS: null,
  LOAD_STAMP_IN_EDITOR_ERROR: null,

  LOAD_DRAFT_IN_EDITOR: null,
  LOAD_DRAFT_IN_EDITOR_SUCCESS: null,
  LOAD_DRAFT_IN_EDITOR_ERROR: null,

  LOAD_EMPTY_DRAFT: null,

  SAVE_DRAFT: null,
  SAVE_DRAFT_SUCCESS: null,
  SAVE_DRAFT_ERROR: null,

  DELETE_DRAFT: null,
  DELETE_DRAFT_SUCCESS: null,
  DELETE_DRAFT_ERROR: null,

  DRAFT_RESET_LAST_ADDED_ITEM: null,
  DRAFT_SET_STATUS: null,

  REQUEST_DRAFTS: null,
  REQUEST_DRAFTS_SUCCESS: null,
  REQUEST_DRAFTS_ERROR: null,
  INVALIDATE_DRAFTS: null,

  CANVAS_ADD_SECTION: null,
  CANVAS_UPDATE_SECTION: null,
  CANVAS_MOVE_SECTION: null,
  CANVAS_DELETE_SECTION: null,

  GALLERY_ADD_IMAGE: null,
  GALLERY_DELETE_IMAGE: null,
  GALLERY_UPDATE_IMAGE: null,
  GALLERY_MOVE_IMAGE: null,

  UPLOAD_MEDIA_THUMBNAIL: null,
  UPLOAD_MEDIA_THUMBNAIL_ERROR: null,
  UPLOAD_MEDIA_THUMBNAIL_SUCCESS: null,

  ADD_GRABBAG_ITEM: null,
  UPDATE_GRABBAG_ITEM: null,
  DELETE_GRABBAG_ITEM: null,

  PLAYER_PLAY: null,
  PLAYER_PAUSE: null,
  PLAYER_PLAY_NEXT: null,
  PLAYER_PLAY_PREVIOUS: null,
  PLAYER_SET_CURRENT_TIME: null,
  PLAYER_CONSIDER_SET_STICKY_MEDIA: null,
  PLAYER_CONSIDER_REMOVE_STICKY_MEDIA: null,
  PLAYER_REGISTER_AUDIO: null,
  PLAYER_UNREGISTER_AUDIO: null,

  ACTIVITY_EXPAND: null,
  ACTIVITY_COLLAPSE: null,

  REQUEST_STAMP_LIKES: null,
  REQUEST_STAMP_LIKES_SUCCESS: null,
  REQUEST_STAMP_LIKES_ERROR: null,

  INVALIDATE_USER_SUBSCRIBERS: null,
  REQUEST_USER_SUBSCRIBERS: null,
  REQUEST_USER_SUBSCRIBERS_SUCCESS: null,
  REQUEST_USER_SUBSCRIBERS_ERROR: null,

  INVALIDATE_USER_SUBSCRIPTIONS: null,
  REQUEST_USER_SUBSCRIPTIONS: null,
  REQUEST_USER_SUBSCRIPTIONS_SUCCESS: null,
  REQUEST_USER_SUBSCRIPTIONS_ERROR: null,

  IMAGE_ADD_TO_GRABBAG: null,
  IMAGE_ADD_TO_GRABBAG_ERROR: null,
  IMAGE_ADD_TO_GRABBAG_SUCCESS: null,

  IMAGE_REMOVE_FROM_GRABBAG: null,
  IMAGE_REMOVE_FROM_GRABBAG_ERROR: null,
  IMAGE_REMOVE_FROM_GRABBAG_SUCCESS: null,

  IMAGE_REMOVE_STAMPLET_ITEM: null,
  IMAGE_REMOVE_STAMPLET_ITEM_ERROR: null,
  IMAGE_REMOVE_STAMPLET_ITEM_SUCCESS: null,

  REQUEST_GRABBAG_IMAGES: null,
  REQUEST_GRABBAG_IMAGES_SUCCESS: null,
  REQUEST_GRABBAG_IMAGES_ERROR: null,

  REQUEST_IMAGE_USED_IN_STAMPS: null,
  REQUEST_IMAGE_USED_IN_STAMPS_SUCCESS: null,
  REQUEST_IMAGE_USED_IN_STAMPS_ERROR: null,

  SEND_DRAFT_FEEDBACK: null,
  SEND_DRAFT_FEEDBACK_SUCCESS: null,
  SEND_DRAFT_FEEDBACK_ERROR: null,

  REQUEST_DRAFT_FEEDBACKS: null,
  REQUEST_DRAFT_FEEDBACKS_SUCCESS: null,
  REQUEST_DRAFT_FEEDBACKS_ERROR: null,
  INVALIDATE_DRAFT_FEEDBACKS: null,

  REQUEST_STAMP_SEARCH: null,
  REQUEST_STAMP_SEARCH_SUCCESS: null,
  REQUEST_STAMP_SEARCH_ERROR: null,

  REQUEST_USER_SEARCH: null,
  REQUEST_USER_SEARCH_SUCCESS: null,
  REQUEST_USER_SEARCH_ERROR: null,

  REQUEST_ZINE_SEARCH: null,
  REQUEST_ZINE_SEARCH_SUCCESS: null,
  REQUEST_ZINE_SEARCH_ERROR: null
});


/** WEBPACK FOOTER **
 ** ./constants/ActionTypes.js
 **/